import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { Loader2, MailCheck } from "lucide-react";

const field = "w-full rounded-lg border border-white/10 bg-white/5 px-4 py-3 outline-none focus:border-primary/50";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMsg(data.message);
    } catch (err) {
      setMsg(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-[hsl(var(--surface))]/90 p-8">
        <Link to="/" className="font-heading text-2xl font-black tracking-tight">Vytali<span className="text-primary">Flix</span></Link>
        <h1 className="mt-6 font-heading text-2xl font-bold">Mot de passe oublié</h1>
        {msg ? (
          <div className="mt-6 flex flex-col items-center gap-3 text-center" data-testid="forgot-sent">
            <MailCheck className="h-12 w-12 text-primary" />
            <p className="text-sm text-muted-foreground">{msg}</p>
            <Link to="/login" className="mt-2 text-primary hover:underline">Retour à la connexion</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <input type="email" required placeholder="Votre e-mail" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email" className={field} />
            <button type="submit" disabled={loading} data-testid="forgot-submit" className="flex w-full items-center justify-center gap-2 rounded-lg bg-primary py-3 font-semibold text-primary-foreground disabled:opacity-60">
              {loading && <Loader2 className="h-4 w-4 animate-spin" />} Envoyer le lien
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
